<template>
  <!-- main content -->
  <v-container fluid fill-height class="custom--container">
    <v-row align-center justify="center" class="flex-grow-1">
      <v-col cols="8" offset="2">
        <v-card class="elevation-0 about--card pa-2">
          <v-card-title class="text-no-wrap justify-center about--text-name">
            <!-- <div class="about--text-name"> -->
            {{ about.name }}
            <!-- </div> -->
          </v-card-title>
          <v-card-text class="about--text-body">
            {{ about.content }}
          </v-card-text>
        </v-card>
      </v-col>
      <scroll-helper :scroll="about.scroll" />
    </v-row>
  </v-container>
</template>

<script>
import ScrollHelper from "./ScrollHelper.vue";
export default {
  components: { ScrollHelper },
  name: "About",
  props: ["about"],
};
</script>
